// src/app/core/auth/no-auth.guard.ts
import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthService } from 'app/core/auth/auth.service';

export const NoAuthGuard: CanActivateFn = (): boolean | UrlTree => {
  const auth   = inject(AuthService);
  const router = inject(Router);

  // se logado: manda para /inicio (não /home)
  return auth.isAuthenticatedSync ? router.parseUrl('/inicio') : true;
};
